<template>
  <div class="page_content">

		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading">
				<span class="module_icon fas fa-folder"></span>
				<span class="module_type_name">Folder Management</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button type="button" class="btn btn-primary" @click="create" aria-label="create">create</button>
				<button type="button" class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
			</div>
		</div>

        <div class="page-content mt-4">
            <div class="page-section">
                <div class="page_section_row row col-12">
                    <div class="heading sub-heading col-4">
                        <label for="title">Private Folder Name</label>
                    </div>
                    <div class="col-5">
                        <b-form-input id="title" type="text"
                            v-model.trim="title" :state="titleState"
                            placeholder="type in the private folder name*"
                            class="module_title private-folder-field"
							aria-label="Private Folder Name"
                            aria-describedby="titleFeedback">
                        </b-form-input>
                        <b-form-invalid-feedback id="titleFeedback">
                            Folder name must not be empty
                        </b-form-invalid-feedback>
                    </div>
                </div>
            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import '../../../assets/module/less/folder-management.less'

  export default {
    name: 'folder-create',
    data () {
      return {
        title: 'Untitled Folder'
      }
    },

    mounted () {
      $('#title').select()
    },

    computed: {
      titleState () {
        return this.title.length >= 2
      }
    },

    methods: {
      ...mapActions([
        'createInstitutionPrivateFolder'
      ]),

      cancel () {
        return this.$router.push({name: 'folderList'})
      },

      create () {
        if (this.titleState) {
          this.$refs.loadingModal.show()
          this.createInstitutionPrivateFolder(this.title).then(res => {
            setTimeout(() => {
              this.$refs.loadingModal.hide()
              this.$notify({
                group: 'notify',
                type: 'success',
                title: '',
                text: 'Private folder "' + this.title + '" created successfully.'
              })
              return this.$router.push({name: 'folderList'})
            }, 1000)
          })
        }
      }
    }
  }
</script>

<style scoped>
    .top-heading {
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 8px;
        height: 42px;
    }

    .page-section {
        padding-top: 25px;
        background: #f5f5f5;
        height: 85px;
        margin-left: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/folderManagement/components/FolderCreate.vue